import { motion, AnimatePresence } from 'framer-motion';

export default function Splash({ visible }) {
  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          className="splash-screen"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.6, ease: 'easeInOut' }}
        >
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            className="text-center"
            style={{ position: 'relative', zIndex: 1 }}
          >
            <div className="splash-logo-frame">
              <div className="breathing-ring" />
              <div className="breathing-ring" />
              <div className="breathing-ring" />
              <img
                src="/intiviv-logo.png?v=4"
                alt="INTIVIV"
                className="splash-brand-mark"
              />
            </div>
            <div className="splash-tagline">Intimate wellness, intelligently guided.</div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
